import styled from 'styled-components'

const Container = styled.div`
    min-height: 350px;
`

const ListBox = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`

export const S = {
    Container,
    ListBox,
}
